<template>
  <div class="formButton">
    <i class="el-icon-plus"></i> <span>{{ itemRender.label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    itemRender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.formButton {
  background-color: #f0f3fd;
  color: #45a8ff;
  text-align: center;
  padding: 10px 0;
}
</style>
